'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var PeerInfo = require('peer-info');

var errcode = require('err-code');

var Message = require('../../message');

var utils = require('../../utils');

module.exports = function (dht) {
  var log = utils.logger(dht.peerInfo.id, 'rpc:get-providers');
  /**
   * Process `GetProviders` DHT messages.
   *
   * @param {PeerInfo} peer
   * @param {Message} msg
   * @returns {Promise<Message>}
   */

  return /*#__PURE__*/function () {
    var _getProviders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peer, msg) {
      var cid, dsKey, _yield$Promise$all, _yield$Promise$all2, has, peers, closer, providers, response;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              cid = new CID(msg.key);
              _context.next = 7;
              break;

            case 4:
              _context.prev = 4;
              _context.t0 = _context["catch"](0);
              throw errcode(new Error("Invalid CID: ".concat(_context.t0.message)), 'ERR_INVALID_CID');

            case 7:
              log('%s', cid.toBaseEncodedString());
              dsKey = utils.bufferToKey(cid.buffer);
              _context.next = 11;
              return Promise.all([dht.datastore.has(dsKey), dht.providers.getProviders(cid), dht._betterPeersToQuery(msg, peer)]);

            case 11:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              has = _yield$Promise$all2[0];
              peers = _yield$Promise$all2[1];
              closer = _yield$Promise$all2[2];
              providers = peers.map(function (p) {
                if (dht.peerStore.has(p)) {
                  return dht.peerStore.get(p);
                }

                return dht.peerStore.put(new PeerInfo(p));
              });

              if (has) {
                providers.push(dht.peerInfo);
              }

              response = new Message(msg.type, msg.key, msg.clusterLevel);

              if (providers.length > 0) {
                response.providerPeers = providers;
              }

              if (closer.length > 0) {
                response.closerPeers = closer;
              }

              log('got %s providers %s closerPeers', providers.length, closer.length);
              return _context.abrupt("return", response);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 4]]);
    }));

    function getProviders(_x, _x2) {
      return _getProviders.apply(this, arguments);
    }

    return getProviders;
  }();
};